<template>
  <div>
    <div class="div-input row pl-3 px-3 mt-2">
      <div :class="['input-custom', { error: isValidate }, classLabelName]">
        <label class="">
          {{ textFloat }}
          <span v-if="isRequired" class="text-danger">*</span>
          <span> :</span>
        </label>
      </div>
      <div :class="['input-custom', { error: isValidate }, classInputName]">
        <div class="d-flex justify-content-center align-items-center">
          <div class="w-100 display-only">
            <input
              :class="['custom-input']"
              :type="type"
              :placeholder="placeholder"
              :name="name"
              :required="required"
              :value="fileNameDisplay"
              :size="size"
              disabled
            />
            <font-awesome-icon
              icon="times-circle"
              class="text-secondary delete-icon pointer"
              v-if="fileName"
              @click="deleteImage"
              :class="[{ 'd-none': cantEdit }]"
            />
          </div>
          <label
            class="mb-0 btn-main btn-upload"
            :size="size"
            :class="[{ 'btn-disable': cantEdit }]"
          >
            <input
              type="file"
              v-on:change="handleFileChange"
              :required="required"
              :name="name"
              accept="image/png, image/jpeg, application/pdf"
              ref="input"
              :disabled="cantEdit"
            />
            <font-awesome-icon
              icon="file-upload"
              color="white"
              class="bg-icon"
              :size="size"
            />
          </label>
        </div>
        <p class="detail-format">{{ text }}</p>
        <div v-if="v && v.$error">
          <span class="text-error" v-if="v.required == false">{{
            $t("required")
          }}</span>
        </div>
        <b-row v-if="fileName" class="mt-1">
          <b-col cols="10" md="6" class="pr-0">
            <b-aspect :aspect="aspect">
              <div
                v-if="['jpg', 'jpeg', 'png'].indexOf(fileTypeDisplay) >= 0 "
                :class="['preview-file']"
                v-bind:style="{
                  'background-image': 'url(' + fileDisplay + ')',
                }"
              ></div>
              <embed 
                v-else-if="['pdf'].indexOf(fileTypeDisplay) >= 0"
                :src="fileDisplay"
                type="application/pdf"
                frameBorder="0"
                scrolling="auto"
                height="100%"
                width="100%"
                allowfullscreen
              />
            </b-aspect>
          </b-col>
          <b-col cols="2" class="px-0">
            <font-awesome-icon
              @click="$refs.modalFile.show()"
              icon="search-plus"
              color="#6c757d"
              class="ml-2 pointer"
              size="lg"
            />
          </b-col>
        </b-row>
      </div>
      <div class="col-2 col-lg-1 p-0 text-right text-lg-left pl-1">
        <b-button
          type="button"
          col="4"
          md="4"
          class="btn-download w-100 ml-0"
          :disabled="isDisable"
          variant="link"
          @click.prevent="downloadItem(fileName)"
        >
          <font-awesome-icon
            icon="file-download"
            color="white"
            class="bg-icon"
            :size="size"
        /></b-button>
      </div>
    </div>
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <b-modal
      id="modalFile"
      ref="modalFile"
      hide-header
      hide-footer
      centered
      body-class="p-4"
      size="xl"
    >
      <div class="modal-header border-0 px-0 pt-0">
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click="$bvModal.hide('modalFile')"
        >
          ×
        </button>
      </div>
      <div>
        <b-container class="p-0">
          <b-row>
            <b-col>
              <div class="w-100 h-100">
                <b-aspect :aspect="aspect">
                  <div
                    v-if="['jpg', 'jpeg', 'png'].indexOf(fileTypeDisplay) >= 0 "
                    :class="['preview-file']"
                    v-bind:style="{
                      'background-image': 'url(' + fileDisplay + ')',
                    }"
                  ></div>
                  <embed 
                    v-else-if="['pdf'].indexOf(fileTypeDisplay) >= 0"
                    :src="fileDisplay"
                    type="application/pdf"
                    frameBorder="0"
                    scrolling="auto"
                    height="100%"
                    width="100%"
                    allowfullscreen
                  />
                </b-aspect>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
export default {
  components: {
    ModalAlertError,
  },
  props: {
    textFloat: {
      required: true,
      type: String,
    },
    text: {
      required: false,
      type: String,
    },
    format: {
      required: true,
      type: String,
    },
    fileName: {
      required: true,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    name: {
      required: false,
      type: String,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    placeholder: {
      required: true,
      type: String,
    },
    size: {
      required: false,
      type: String,
    },
    downloadPath: {
      required: false,
      type: String,
    },
    v: {
      required: false,
      type: Object,
    },
    classLabelName: {
      required: false,
      type: String,
    },
    classInputName: {
      required: false,
      type: String,
    },
    cantEdit: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      file: "",
      value: "",
      type: {
        all: ["image/jpeg", "image/png", "application/pdf", ""],
        file: ["image/jpeg", "image/png", "application/pdf"],
        pdf: ["application/pdf"],
        png: ["image/png"],
        image: ["image/jpeg", "image/png"],
        video: ["video/mp4"],
        excel: [
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ],
      },
      error: "",
      hasError: false,
      hasImage: false,
      imgModal: null,
      msgModal: null,
      modalAlertShow: false,
      isSuccess: false,
      modalMessage: "",
      fileDisplay: this.fileName,
      aspect: "1:1.4142"
    };
  },
  computed: {
    fileTypeDisplay: function () {
      if (this.fileName) {
        if (this.fileName.includes("http")) {
          return this.fileName.split(".").pop();
        } else {
          return this.value.type.split("/").pop();
        }
      } else {
        return "";
      }
    },
    fileNameDisplay: function () {
      if (this.fileName) {
        if (this.fileName.includes("http")) {
          return this.fileName.split("\\").pop().split("/")[4];
        } else {
          return this.fileName;
        }
      } else {
        return this.fileName;
      }
    },
    isDisable: function () {
      if (this.fileName) {
        if (this.fileName.includes(this.$baseUrl)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  methods: {
    handleFileChange(e) {
      this.hasError = false;
      this.error = "";
      var _validFileExtensions = this.type.file;
      if (this.format == "image") {
        _validFileExtensions = this.type.image;
      } else if (this.format == "video") {
        _validFileExtensions = this.type.video;
      } else if (this.format == "all") {
        _validFileExtensions = this.type.all;
      } else if (this.format == "pdf") {
        _validFileExtensions = this.type.pdf;
      } else if (this.format == "excel") {
        _validFileExtensions = this.type.excel;
      }
      this.value = e.target.files[0];
      if (e.target.files.length) {
        if (_validFileExtensions.indexOf(this.value.type) < 0) {
          (this.modalMessage = `${this.$t("fileNotSupport")}`),
            this.$refs.modalAlertError.show();
          return;
        } else if (
          this.value.size > 10000000 &&
          (this.format == "image" || this.format == "pdf")
        ) {
          (this.modalMessage = `${this.$t("fileIsTooLarge")}`),
            this.$refs.modalAlertError.show();
          return;
        } else if (
          this.value.size > 50000000 &&
          (this.format == "video" || this.format == "all")
        ) {
          (this.modalMessage = `${this.$t("fileIsTooLarge")}`),
            this.$refs.modalAlertError.show();
          return;
        } else if (this.value.size > 10000000 && this.format == "excel") {
          (this.modalMessage = `${this.$t("fileIsTooLarge")}`),
            this.$refs.modalAlertError.show();
          return;
        } else {
          this.$emit("onFileChange", this.value);
        }
      } else {
        this.value = "";
        this.$refs.input.value = "";
        this.hasError = true;
      }
      this.handleFileChangeToDisplay(this.value);
    },
    handleFileChangeToDisplay(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileDisplay = reader.result;
      };
    },
    downloadItem: async function (path) {
      let pathFile = path;

      var name_without_ext = path
        .split("\\")
        .pop()
        .split("/")
        .pop()
        .split(".")[0];

      axios({
        url: pathFile,
        method: "GET",
        // headers: null,
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `${name_without_ext}.${response.data.type.split("/").pop(-1)}`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    deleteImage() {
      this.$emit("delete", true);
      this.hasImage = false;
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.detail-format {
  color: #9b9b9b;
  font-size: 12px;
  margin-top: 3px;
  margin-bottom: 0px;
}
/* .bg-icon {
  width: 25px;
  height: 25px;
  margin: 5px 0px;
} */
.bg-icon.fa-lg {
  margin: 8px 0px;
}
.div-input {
  /* margin-bottom: 15px; */
  position: relative;
  white-space: nowrap;
}
.input-custom {
  padding: 0px;
}
.input-custom > label {
  color: #16274a;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
  width: 100%;
}
input.custom-input {
  color: #16274a;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 0px;
  padding: 5px 10px;
}
label[size="lg"].btn-main,
input[size="lg"].custom-input {
  height: 45px;
}
.input-custom.error .custom-input {
  border-color: red !important;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgba(22, 39, 74, 0.4);
}
:-ms-input-placeholder {
  /* Internet Explorer */
  color: rgba(22, 39, 74, 0.4);
}
::placeholder {
  color: rgba(22, 39, 74, 0.4);
}
.custom-input {
  display: block;
  border: none;
  width: 100%;
}
.text-desc {
  color: #16274a;
  font-size: 15px;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.display-only {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.btn-main {
  min-width: 90px !important;
  text-align: center;
  height: 37px;
  vertical-align: middle;
  cursor: pointer;
  background: #16274a;
  color: white;
  padding: 10px;
}
.btn-download-file {
  padding: 0;
  text-decoration: underline;
}
.btn-download {
  margin-top: 0px !important;
  height: 37px;
}
.delete-icon {
  position: absolute;
  right: 5%;
  top: 10px;
}
.btn-disable {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-disable:hover {
  background-color: #092d53 !important;
  color: #ffffff !important;
}
.image-16-9 {
  padding-bottom: 56.25%;
}
.preview-file {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  /* background-size: cover; */
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 2px dashed #bfbfbf;
  margin-bottom: 15px;
  position: relative;
  background-size: contain !important;
}
@media (max-width: 767.98px) {
  .btn-upload {
    width: 41px !important;
    min-width: 41px !important;
  }
  .input-custom > label {
    font-size: 15px;
  }
  .detail-format {
    font-size: 11px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .input-custom > div {
    margin-left: 25px;
  }
  .input-custom > p {
    margin-left: 25px;
  }
}
</style>
